import React from "react";
import { URLImgFront } from '../../../config/URLDB';

class ProductoCard extends React.Component {
    render() {
        const { producto, onDetalle } = this.props;

        return (
            <div className="col mb-4">
                <div className="h-100">
                    <div className="planestimulos-premios-card">
                        <img src={`${URLImgFront}/assets/EstrategiasComerciales${producto.img}`} alt={producto.nombre} />
                        <div className="planestimulos-premios-card-title">
                            {producto.descredencion}
                        </div>
                        <div className="planestimulos-premios-card-puntos font-weight-bold font-italic">
                            {producto.valor} puntos
                        </div>
                        <button className="planestimulos-btn-detalles" onClick={() => onDetalle(producto)}> Detalles </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductoCard;